import BaseApi from '../base/base'
import StripeToken from '../../models/stripe_token'

export default class StripeTokenApi extends BaseApi {
  constructor() {
    super()
    this.path = '/stripe_tokens'
  }

  async show(token: string) {
    this.path = `/stripe_tokens/${token}`
    const response = await this.getRequest()
    return new StripeToken(response.data)
  }
}
